import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare, faTrash, faTimes } from '@fortawesome/free-solid-svg-icons'

type TallyBulkBarProps = {
  selectedCount: number
  deletableCount: number
  linxupSkippedCount: number
  onClear: () => void
  onEdit: () => void
  onDelete: () => void
}

export const TallyBulkBar: React.FC<TallyBulkBarProps> = ({
  selectedCount,
  deletableCount,
  linxupSkippedCount,
  onClear,
  onEdit,
  onDelete,
}) => {
  if (selectedCount <= 0) return null

  return (
    <div className="mb-3 shrink-0 rounded-box border border-primary/30 bg-primary/5 px-3 py-2 flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium">
        {selectedCount} selected
        {linxupSkippedCount > 0 ? (
          <span className="font-normal text-base-content/60">
            {' '}
            · {linxupSkippedCount} Linxup (can’t delete)
          </span>
        ) : null}
      </span>
      <div className="flex flex-wrap gap-2 ml-auto">
        <button type="button" className="btn btn-ghost btn-sm" onClick={onClear}>
          <FontAwesomeIcon icon={faTimes} />
          Clear
        </button>
        <button type="button" className="btn btn-outline btn-sm" onClick={onEdit}>
          <FontAwesomeIcon icon={faPenToSquare} />
          Edit
        </button>
        <button
          type="button"
          className="btn btn-error btn-outline btn-sm"
          onClick={onDelete}
          disabled={deletableCount <= 0}
          title={deletableCount <= 0 ? 'No deletable items selected' : undefined}
        >
          <FontAwesomeIcon icon={faTrash} />
          Delete{deletableCount > 0 ? ` (${deletableCount})` : ''}
        </button>
      </div>
    </div>
  )
}

export default TallyBulkBar
